import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../_services/authentication.service'

@Component({
  selector: 'app-app-dashboard-navigation',
  templateUrl: './app-dashboard-navigation.component.html',
  styleUrls: ['./app-dashboard-navigation.component.scss'],
})
export class AppDashboardNavigationComponent implements OnInit {
  public href: string
  countryName: string

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.href = this.router.url
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
  }
  isPage(page) {
    return this.href.includes(page)
  }
}
